import React from "react";
import "../../Css/Loader.css";
const loader = () => {
  return (
    <div className="loader">
      <div className="bodyloader root">
        <main aria-label="loading screen" className="pl-5 mainloader">
          <div className="preloader">
            <div className="preloader__square"></div>
            <div className="preloader__square"></div>
            <div className="preloader__square"></div>
            <div className="preloader__square"></div>
          </div>
          <div className=" spinner">
            <span>L</span>
            <span>O</span>
            <span>A</span>
            <span>D</span>
            <span>I</span>
            <span>N</span>
            <span>G</span>
          </div>
        </main>
      </div>
    </div>
  );
};

export default loader;
